/* src/app/components/chat-list/group-userlist/group-userlist.component.scss */
.list-wrapper ul li {
  color: var(--textsecondarycolor) !important;
}
.list-wrapper ul li .group-identify {
  top: 10px !important;
}
.list-wrapper ul li .group-identify .pi {
  font-size: 1.3rem !important;
  color: #959595 !important;
}
.list-wrapper ul li .badge-count {
  bottom: 0px !important;
}
.list-wrapper ul li.active {
  background: var(--listbackgoundhover) !important;
  color: var(--listcolor) !important;
  border-top: 1px solid #4bf768;
  border-bottom: 1px solid #4bf768;
}
.list-wrapper ul li.active .list-active,
.list-wrapper ul li.active .chat-msg-text {
  color: var(--listcolor) !important;
}
.list-wrapper ul li.active ::ng-deep .empty-img {
  background: #9affc6 !important;
}
.list-wrapper ul li:hover {
  background: var(--listbackgoundhover) !important;
}
.group-members .fa-times {
  color: rgb(195, 12, 12) !important;
}
.new-group-members .fa-check {
  color: var(--listcolor) !important;
}
.list-wrapper.list-overflow {
  height: calc(100vh - 220px) !important;
}
/*# sourceMappingURL=group-userlist.component.css.map */
